export default __webpack_public_path__ + "static/media/login.32e3bd42.png";